import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { QueryClient, QueryClientProvider } from "react-query";
import { CalculatorV2ConfigurationModel } from "./models/calculator-configuration";
import { InfoPanelProvider } from "./views/components/InfoPanel";

const queryClient = new QueryClient();

const element: HTMLElement = document.getElementById("calculatorV2Widget") as HTMLElement;

if (element != null) {
  const configurationData: string = element.getAttribute("data-configuration") as string;
  const configuration = JSON.parse(configurationData) as CalculatorV2ConfigurationModel;
  const personaID: string = element.getAttribute("data-persona") as string;
  const apiUrl: string = element.getAttribute("data-api") as string;

  if (!configuration.Brussels) {
    configuration.Brussels = { ...configuration.Flanders, Persona: "0" };
    configuration.Brussels.Steps = {
      ...configuration.Brussels.Steps,
      ["Region"]: {
        ...configuration.Brussels.Steps["Region"],
        Title: "Brussels " + configuration.Brussels.Steps["Region"].Title,
      },
    };
  }
  if (!configuration.Wallonia) {
    configuration.Wallonia = { ...configuration.Flanders, Persona: "2" };
    configuration.Wallonia.Steps = {
      ...configuration.Wallonia.Steps,
      ["Region"]: {
        ...configuration.Wallonia.Steps["Region"],
        Title: "Wallonia " + configuration.Wallonia.Steps["Region"].Title,
      },
    };
  }

  ReactDOM.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <InfoPanelProvider>
          <App
            configuration={configuration}
            personaID={personaID}
            translations={configuration.Translations}
            apiUrl={apiUrl}
          />
        </InfoPanelProvider>
      </QueryClientProvider>
    </React.StrictMode>,
    element
  );
}
